import Vue from 'vue'
import vuetify from '@/plugins/vuetify';

import VuetifyConfirm from 'vuetify-confirm'
Vue.use(VuetifyConfirm, { vuetify })


